<template>
  <footer>
      <b-container fluid class="min-height-100">
        <b-row class="min-height-100">
      <b-col md="6" class="d-flex justify-content-center align-items-center py-5 py-md-0">
        <p class="text-uppercase m-0 pr-5">{{ $t('general.share') }}</p>
        <a target="_blank" class="ml-2" :href="'https://www.facebook.com/sharer.php?u=' + share + '/' + this.language + '/'"><Facebook /></a>
        <a target="_blank" class="ml-2" :href="'https://www.linkedin.com/shareArticle?url=' + share + '/' + this.language + '/'"><LinkedIn /></a>
        <a target="_blank" class="ml-2" :href="'https://twitter.com/share?url=' + share + '/' + this.language + '/'"><Twitter /></a>
        <a target="_blank" class="ml-2" :href="'https://api.whatsapp.com/send?text=' + share + '/' + this.language + '/'"><WhatsApp /></a>
        <a target="_blank" class="ml-2" :href="'mailto:?subject=' + share + '/' + this.language + '/'"><Email /></a>
      </b-col>
      <b-col md="6" class="d-flex justify-content-center align-items-center pb-5 pb-md-0">
        <div class="footer-links text-center">
          <a :href="$t('websites.url.raseborg')" target="_blank" class="d-block">{{ $t('websites.text.raseborg') }}</a>
          <a :href="$t('websites.url.visitraseborg')" target="_blank" class="d-block">{{ $t('websites.text.visitraseborg') }}</a>
        </div>
      </b-col>
        </b-row>
      </b-container>
  </footer>
</template>

<script>
import Facebook from '@/assets/svg/unelmakone--facebook.svg'
import Email from '@/assets/svg/unelmakone-email.svg'
import LinkedIn from '@/assets/svg/unelmakone-linkedin.svg'
import Twitter from '@/assets/svg/unelmakone-twitter.svg'
import WhatsApp from '@/assets/svg/unelmakone-whatsapp.svg'
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  components: { Facebook, Email, LinkedIn, Twitter, WhatsApp },
  computed: {
    ...mapState(['language']),
    share () {
      return window.location.origin
    }
  }
}
</script>
